import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const ImpressumPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Back button */}
        <button
          onClick={() => navigate('/')}
          className="mb-8 px-4 py-2 bg-secondary hover:bg-secondary/80 text-white rounded-xl flex items-center gap-2 transition-all"
        >
          <ArrowLeft className="w-5 h-5" />
          Zurück
        </button>

        <h1 className="text-4xl font-bold mb-8">Impressum</h1>

        <div className="space-y-8 text-muted-foreground">
          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="mb-2"><strong>Freys Media</strong></p>
            <p>Inhaber: Kenny Frey</p>
            <p>Wöschhalde 7</p>
            <p>78052 VS-Villingen</p>
            <p>Deutschland</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Kontakt</h2>
            <p>Telefon: 0173 4793306</p>
            <p>WhatsApp: +49 173 4793306</p>
            <p>E-Mail: kenny@freysmedia.de</p>
            <p>Alternative E-Mail: freysmedia@gmail.com</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Umsatzsteuer</h2>
            <p>Kleinunternehmer gemäß § 19 UStG</p>
            <p className="text-sm mt-2">
              Als Kleinunternehmer im Sinne von § 19 Abs. 1 UStG wird keine Umsatzsteuer berechnet.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>Kenny Frey</p>
            <p>Wöschhalde 7</p>
            <p>78052 VS-Villingen</p>
            <p>Deutschland</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
              <a 
                href="https://ec.europa.eu/consumers/odr/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[hsl(var(--accent))] hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-4 text-sm">
              <strong>Wichtiger Hinweis:</strong> Die Plattform zur Online-Streitbeilegung (OS) wird zum 20.7.2025 
              endgültig eingestellt. Die Einreichung von Beschwerden auf der OS-Plattform wird daher bereits am 
              20.3.2025 eingestellt.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-4">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der 
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen 
              werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="mt-4">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche 
              Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-foreground mb-4">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p className="mt-4">
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. 
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter 
              beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
